import React from 'react'
import { Box } from '@material-ui/core'

export const AccordionInfoContainer: React.FC = ({ children }) => {
  return (
    <Box sx={{
      gap: 3,
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }
    }}>
      {children}
    </Box>
  )
}
